module.exports = __webpack_public_path__ + "images/peeler-eb32ed86c2be1e937136e5991ae2a75c.png";